import module from 'contabilidad/polizas/module.js'
import * as moment from 'moment'

export class ContabilidadPolizasService {
  constructor ($api) {
    this.$api = $api
  }

  obtenerClientes () {
    return this.$api.get('/kendu/contabilidad/polizas/clientesCuentasBancarias')
  }

  traerNominas (fechaInicio, fechaFin, idOperadora, idsEmpresas, tipoMoneda) {
    return this.$api.get('/kendu/contabilidad/polizas/traerNominas', {
      fecha_inicio: moment(fechaInicio).format('YYYY-MM-DD'),
      fecha_fin: moment(fechaFin).format('YYYY-MM-DD'),
      ids_empresas: idsEmpresas,
      id_operadora: idOperadora,
      Tipo_Moneda: tipoMoneda || '',
    })
  }

  obtenerOperadoras () {
    return this.$api.get('/kendu/contabilidad/polizas/operadoras')
  }

  obtenerEmpresas (idOperadora) {
    return this.$api.get('/kendu/contabilidad/polizas/operadoras/empresas', {
      idOperadora: idOperadora,
    })
  }
}

module.service('ContabilidadPolizas', ContabilidadPolizasService)



// WEBPACK FOOTER //
// ./src/contabilidad/polizas/services/Polizas.js